"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.tableLayouts = exports.Roboto = void 0;

var _docFlux = require("@harvest-profit/doc-flux");

var _pdfmake = _interopRequireDefault(require("pdfmake/build/pdfmake"));

var _Parser = _interopRequireDefault(require("./Parser"));

var _Utilities = require("./DOMComponents/Utilities");

var _styles = _interopRequireWildcard(require("./styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * The generated document object.  Just call download
 * @module GeneratedDocument
 */
var GeneratedDocument = /*#__PURE__*/function () {
  function GeneratedDocument(docDefinition, settings, documentStyling) {
    _classCallCheck(this, GeneratedDocument);

    var restOfSettings = (0, _Utilities.pick)(settings, ['pageSize', 'pageOrientation', 'pageMargins', 'background', 'info']);

    var finalDocDefinition = _objectSpread({
      content: docDefinition,
      styles: documentStyling.css,
      defaultStyle: documentStyling["default"]
    }, restOfSettings);

    if (docDefinition.header) finalDocDefinition.header = docDefinition.header;
    if (docDefinition.footer) finalDocDefinition.footer = docDefinition.footer;
    this.doc = _pdfmake["default"].createPdf(finalDocDefinition, documentStyling.tableLayouts, documentStyling.fonts);
    this.documentName = settings.name || 'New Document.pdf';
  }

  _createClass(GeneratedDocument, [{
    key: "download",
    value: function download() {
      this.doc.download(this.documentName);
    }
  }, {
    key: "open",
    value: function open() {
      this.doc.open();
    }
  }]);

  return GeneratedDocument;
}();

var Roboto = {
  normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
  bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
  italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
  bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
};
exports.Roboto = Roboto;
var _tableLayouts = {
  zebra: {
    fillColor: function fillColor(rowIndex) {
      return rowIndex % 2 === 0 ? '#CCCCCC' : null;
    }
  }
};
exports.tableLayouts = _tableLayouts;
var defaultDocumentStyling = {
  css: _styles["default"],
  fonts: {
    Roboto: Roboto
  },
  "default": _styles.defaultStyles,
  tableLayouts: _tableLayouts
};
/**
 * The DocFlux Document (exported as Document).
 * @module PDFDocument
 */

var PDFDocument = /*#__PURE__*/function (_Document) {
  _inherits(PDFDocument, _Document);

  var _super = _createSuper(PDFDocument);

  function PDFDocument() {
    _classCallCheck(this, PDFDocument);

    return _super.apply(this, arguments);
  }

  _createClass(PDFDocument, null, [{
    key: "documentSettings",
    value: function documentSettings() {
      return {
        name: 'New Document.pdf'
      };
    }
  }, {
    key: "styleSheet",
    // DEPRECATED: Use documentStyling now
    value: function styleSheet() {
      return {};
    } // DEPRECATED: Use documentStyling now

  }, {
    key: "tableLayouts",
    value: function tableLayouts() {
      return _tableLayouts;
    }
  }, {
    key: "createDocument",
    value: function createDocument(docDefinition, props) {
      var docStyling = defaultDocumentStyling;
      var definedDocStyling = this.documentStyling || {};
      docStyling.fonts = definedDocStyling.fonts || docStyling.fonts;
      docStyling["default"] = definedDocStyling["default"] || docStyling["default"];

      if (!docStyling["default"].font) {
        var availableFonts = Object.keys(docStyling.fonts);

        if (availableFonts.length > 0) {
          docStyling["default"].font = availableFonts[0];
        } else {
          docStyling["default"].font = 'Roboto';
        }
      }

      docStyling.tableLayouts = definedDocStyling.tableLayouts || docStyling.tableLayouts;
      docStyling.css = _objectSpread(_objectSpread({}, docStyling.css), definedDocStyling.css || this.styleSheet());
      return new GeneratedDocument(docDefinition, this.documentSettings(props), docStyling);
    }
  }, {
    key: "createBuilder",
    value: function createBuilder() {
      return null;
    }
  }]);

  return PDFDocument;
}(_docFlux.Document);

_defineProperty(PDFDocument, "parser", _Parser["default"]);

_defineProperty(PDFDocument, "documentStyling", null);

var _default = PDFDocument;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@harvest-profit/doc-flux-pdfs/dist/PDFDocument.js
// module id = 54
// module chunks = 0